import React from "react";

const Footer = () => {
    
    return (
        <footer>
            <div className="wrap_inner">
                <p className="copyright">Designed & developed by Hyeongyu Park</p>
                <p className="github"><a href="https://github.com/Rafdidas/movie_db" target="_blank" rel="noopener noreferrer">View Code</a></p>
            </div>
        </footer>
    );
};

export default Footer;